import { render, staticRenderFns } from "./CreateCustomerUser.vue?vue&type=template&id=da3c6344"
import script from "./CreateCustomerUser.vue?vue&type=script&lang=js"
export * from "./CreateCustomerUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports